<template>
  <div class="curriculum-selector">
    <b-field label="Curriculum" label-position="on-border" expanded>
      <b-select
        :value="selectedId"
        placeholder="Select a curriculum"
        expanded
        @input="$emit('select', $event)"
      >
        <option value="">Select a curriculum</option>
        <option
          v-for="curriculum in curriculums"
          :key="curriculum.id"
          :value="curriculum.id"
        >
          {{ curriculum.title }} ({{ curriculum.status }})
        </option>
      </b-select>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "CurriculumSelector",
  props: {
    curriculums: {
      type: Array,
      required: true,
    },
    selectedId: {
      type: String,
      default: "",
    },
  },

  watch: {
    curriculums: {
      immediate: true,
      handler(newCurriculums) {
        if (newCurriculums.length > 0 && !this.selectedId) {
          this.$emit("select", newCurriculums[0].id);
        }
      },
    },
  },
};
</script>
